import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import { bindInViewTimeline } from '../util/animations'

class BannerMosaic {
  constructor ($el) {
    this.$el = $el
    this.onCompleteTimelineIn = this.onCompleteTimelineIn.bind(this)
    this.timeline = new TimelineMax({
      paused: true,
      delay: 0.2,
      onComplete: this.onCompleteTimelineIn,
    })
    this.timeline.timeScale(0.8)
    this.buildTimelineIn()

    bindInViewTimeline($el, this.timeline)
  }

  buildTimelineIn () {
    const $el = this.$el
    this.timeline
      .staggerFromTo(
        $el.find('.banner-mosaic__banner .image'),
        1,
        { x: '-100%' },
        { x: '0%', ease: Power3.easeInOut },
        0.1,
        0
      )
      .staggerFromTo(
        $el.find('.banner-mosaic__banner .bg'),
        1,
        { x: '100%' },
        { x: '0%', ease: Power3.easeInOut },
        0.1,
        0
      )
      .staggerFromTo(
        $el.find('.banner-mosaic__banner .bg'),
        0.5,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.1,
        0
      )
      .staggerFromTo(
        $el.find('.banner-mosaic__banner .title'),
        0.8,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.1,
        1
      )
      .staggerFromTo(
        $el.find('.line--v'),
        1.6,
        { scaleY: '0' },
        { scaleY: '1', ease: Power3.easeInOut },
        0.2,
        0.2
      )
      .staggerFromTo(
        $el.find('.line--h'),
        1.6,
        { scaleX: '0' },
        { scaleX: '1', ease: Power3.easeInOut },
        0.2,
        0.3
      )
  }

  onCompleteTimelineIn () {
    this.$el.find('a').each(function (i, a) {
      const $a = $(a)
      const timeline = new TimelineMax()
      $a.hover(
        () => {
          timeline
            .clear()
            .to($a.find('.bg'), 0.5, { scale: 1.05, ease: Power3.easeOut }, 0)
            .to($a.find('.title'), 0.5, { background: 'rgba(28, 28, 28, 0.15)', ease: Power0.easeNone }, 0)
            .to($a.find('.name, .explore'), 0.5, { letterSpacing: '0.84em', ease: Power3.easeInOut }, 0)
            .to($a.find('.name'), 0.25, { opacity: 0, ease: Power0.easeNone }, 0)
            .to($a.find('.explore'), 0.25, { opacity: 1, ease: Power0.easeNone }, 0.25)
        },
        () => {
          timeline
            .clear()
            .to($a.find('.bg'), 0.5, { scale: 1, ease: Power3.easeOut }, 0)
            .to($a.find('.title'), 0.5, { background: 'rgba(28, 28, 28, 0)', ease: Power0.easeNone }, 0)
            .to($a.find('.name, .explore'), 0.5, { letterSpacing: '0.5em', ease: Power3.easeInOut }, 0)
            .to($a.find('.explore'), 0.25, { opacity: 0, ease: Power0.easeNone }, 0)
            .to($a.find('.name'), 0.25, { opacity: 1, ease: Power0.easeNone }, 0.25)
        }
      )
    })
  }
}

export default BannerMosaic



// WEBPACK FOOTER //
// ./scripts/components/BannerMosaic.js